export default __webpack_public_path__ + "static/media/564.1bdcaef8.jpg";